import React from "react";
import { Box, Typography } from "@mui/material";

const SystemLoadingOverlay = ({
  title = "Cargando sistema",
  subtitle = "Preparando tu espacio de trabajo...",
  color = "#6C4DE2",
  logo = "/images/isotipo-hitpoly.png",
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0f0f1a",
        zIndex: 110,
        overflow: "hidden",
      }}
    >
      {/* Resplandor de fondo animado */}
      <Box
        sx={{
          position: "absolute",
          width: "520px",
          height: "520px",
          borderRadius: "50%",
          background: `radial-gradient(circle, ${color}33 0%, transparent 70%)`,
          filter: "blur(30px)",
          animation: "hs-loading-pulse 2.4s ease-in-out infinite",
          "@keyframes hs-loading-pulse": {
            "0%, 100%": { transform: "scale(1)", opacity: 0.7 },
            "50%": { transform: "scale(1.25)", opacity: 1 },
          },
        }}
      />
      {/* Anillo exterior giratorio */}
      <Box
        sx={{
          position: "absolute",
          width: "260px",
          height: "260px",
          borderRadius: "50%",
          border: "2px solid transparent",
          borderTopColor: color,
          borderRightColor: `${color}55`,
          animation: "hs-loading-spin 1.2s linear infinite",
          "@keyframes hs-loading-spin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: "340px",
          height: "340px",
          borderRadius: "50%",
          border: "1px dashed transparent",
          borderTopColor: `${color}44`,
          animation: "hs-loading-spin-rev 2s linear infinite",
          "@keyframes hs-loading-spin-rev": {
            "0%": { transform: "rotate(360deg)" },
            "100%": { transform: "rotate(0deg)" },
          },
        }}
      />

      {/* Contenido central */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          px: 3,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="HitPoly"
          sx={{
            width: 88,
            height: 88,
            objectFit: "contain",
            borderRadius: "20px",
            boxShadow: `0 8px 40px ${color}66`,
            mb: 4,
            animation: "hs-loading-float 2s ease-in-out infinite",
            "@keyframes hs-loading-float": {
              "0%, 100%": { transform: "translateY(0)" },
              "50%": { transform: "translateY(-8px)" },
            },
          }}
        />
        <Typography
          variant="h5"
          sx={{
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.5,
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#9aa0b5", fontWeight: 500, mb: 4 }}
        >
          {subtitle}
        </Typography>

        {/* Barra de progreso animada */}
        <Box sx={{ width: 240, position: "relative" }}>
          <Box
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: "#26263a",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "40%",
                borderRadius: 3,
                background: `linear-gradient(90deg, ${color}33, ${color}, ${color}33)`,
                backgroundSize: "200% 100%",
                animation: "hs-loading-bar 1.2s ease-in-out infinite",
                "@keyframes hs-loading-bar": {
                  "0%": { transform: "translateX(-120%)" },
                  "100%": { transform: "translateX(320%)" },
                },
              }}
            />
          </Box>
        </Box>

        <Typography
          variant="caption"
          sx={{ color: "#6a7085", mt: 2, letterSpacing: 1.5, textTransform: "uppercase" }}
        >
          HitPoly
        </Typography>
      </Box>
    </Box>
  );
};

export default SystemLoadingOverlay;
